<div class="cmdb-dashboard-container">
	<div class="header">
		<div class="main-header-row">
			<span class="title">Dashboard CMDB</span>
			<div class="button-container">
				<div class="button-with-label">
					<span>{{ this.labels.lbl_mostrar_inativos }}</span>
					<cpi-toggle-switch
						[invertToggle]="false"
						[switchOn]="selectedValuesFilters.showInactiveCis"
						(switchOnChange)="toggleInactiveCis($event)">
					</cpi-toggle-switch>
				</div>

				<div class="button-with-label">
					<span>{{ this.labels.lbl_geral_exibir_valores }}</span>
					<cpi-toggle-switch
						[invertToggle]="false"
						[switchOn]="selectedValuesFilters.showChartValues"
						(switchOnChange)="toggleChartValues($event)">
					</cpi-toggle-switch>
				</div>
				<button (click)="clearFilters()">Limpar filtros</button>
				<button class="small" (click)="collapseFilters = !collapseFilters">
					<fa-icon [icon]="icons.faFilter"></fa-icon>
					<span class="icon" [ngClass]="{ rotate: collapseFilters }">
						<fa-icon [icon]="icons.faAngleDown"></fa-icon>
					</span>
				</button>
			</div>
		</div>
	</div>

	<div class="body">
		<div class="sticky-filter-container">
			<div class="title">
				<span class="section-title">{{ this.labels.lbl_status_movimentacao_ativos }}</span>
			</div>
			<div class="main-filters-container" [mspSmoothCollapse]="collapseFilters">
				<div class="date-picker-filter-option">
					<div
						class="date-range-option"
						[ngClass]="{
							active: this.selectedValuesFilters.filterDate === 'today',
						}"
						(click)="this.selectedValuesFilters.filterDate = 'today'; filterValues()">
						{{ this.labels.lbl_geral_dia }}
					</div>
					<div
						class="date-range-option"
						[ngClass]="{
							active: this.selectedValuesFilters.filterDate === 'week',
						}"
						(click)="this.selectedValuesFilters.filterDate = 'week'; filterValues()">
						{{ this.labels.lbl_geral_semana }}
					</div>
					<div
						class="date-range-option"
						[ngClass]="{
							active: this.selectedValuesFilters.filterDate === 'month',
						}"
						(click)="this.selectedValuesFilters.filterDate = 'month'; filterValues()">
						{{ this.labels.lbl_geral_mes }}
					</div>

					<div
						class="date-range-option custom"
						[ngClass]="{
							active: this.selectedValuesFilters.filterDate === 'custom',
						}"
						#dateRangePickerTrigger>
						<fa-icon [icon]="icons.faCalendar" (click)="openDatePicker()"></fa-icon>
					</div>
					<date-range-picker
						[showTime]="false"
						(datesConfirmed)="selectDate($event)"
						(calendarClosed)="isDatePickerOpen = false"
						[mspDropdownBehaviour]="isDatePickerOpen"
						[mspDropdownBehaviourTrigger]="dateRangePickerTrigger"
						(mspDropdownBehaviourCollapsed)="isDatePickerOpen = false">
					</date-range-picker>
				</div>
			</div>
		</div>

		<div class="main-chart-container">
			<div class="chart-item">
				<div class="title">
					<span class="text-item">{{ this.labels.lbl_geral_movimentacoes_ativos_periodo_tempo }}</span>
					<div class="chart-button-container">
						<button class="export-button" (click)="exportDataMoviments()">
							{{ this.labels.lbl_geral_exportar }} {{ labels.lbl_geral_movimentacoes }}
						</button>
					</div>
				</div>
				@if (isLoadingbarChartData) {
					<cpi-square-post-loading-effect orientation="vertical" barThickness="3rem"></cpi-square-post-loading-effect>
				}
				@if (!isLoadingbarChartData) {
					<canvas class="chart-size" baseChart [data]="barChartData" [options]="barChartOptions" chartType="bar"></canvas>
				}
			</div>
		</div>

		<div class="sticky-filter-container">
			<div class="title">
				<span class="section-title">Quantidades de CI</span>
			</div>
			<div class="main-filters-container" [mspSmoothCollapse]="collapseFilters">
				<div class="filter-row">
					<div class="filter-option">
						<span>{{ this.labels.lbl_asset_tipo_ci }}</span>
						<msp-multi-checkbox-select
							[options]="availableCiTypes"
							[cleanValues]="triggerClearSelection"
							[allLabel]="labels.lbl_geral_todos"
							[selectedLabel]="labels.lbl_geral_selecionados"
							(selectedValuesChange)="handleCiTypeSelection($event)">
						</msp-multi-checkbox-select>
					</div>

					<div class="filter-option">
						<span>{{ this.labels.lbl_localidade }}</span>
						<select (change)="selectLocation($any($event.target).value)">
							<option [value]="''" [selected]="this.selectedValuesFilters.location === ''">
								{{ labels.lbl_geral_todos }}
							</option>
							<option
								[value]="location.id_location"
								[selected]="this.selectedValuesFilters.location === location.id_location"
								*ngFor="let location of availableLocations">
								{{ location.site }} - {{ location.location }}
							</option>
						</select>
					</div>

					<div class="filter-option">
						<span>{{ this.labels.lbl_status_ci }}</span>
						<msp-multi-checkbox-select
							[options]="availableStatus"
							[cleanValues]="triggerClearSelection"
							[allLabel]="labels.lbl_geral_todos"
							[selectedLabel]="labels.lbl_geral_selecionados"
							(selectedValuesChange)="handleStatusSelection($event)">
						</msp-multi-checkbox-select>
					</div>

					<button class="export-button" (click)="exportData()">
						{{ this.labels.lbl_geral_exportar }}
					</button>
				</div>
			</div>
		</div>

		<div class="main-kpi-container">
			<div class="item" *ngFor="let kpi of flowList">
				<span class="text-item">{{ this.labels[kpi.label] }}</span>
				<div class="icons-right">
					<!-- <span><fa-icon [icon]="icons.faExternalLink"></fa-icon></span> -->
				</div>
				<cpi-dot-bounce-loading-effect [color]="'black'" *ngIf="isLoadingKpiQtd"></cpi-dot-bounce-loading-effect>
				<span class="text-item" *ngIf="!isLoadingKpiQtd">{{ kpi.quantity }}</span>
			</div>
		</div>

		<div class="main-kpi-container ci-indicators-section">
			@if (isLoadingCiIndicators) {
				<div class="empty-ci-indicators">
					<cpi-square-post-loading-effect barThickness="3rem"></cpi-square-post-loading-effect>
				</div>
			}
			@if (!isLoadingCiIndicators && cmdbCockpitCards.length === 0 && cmdbCockpitCharts.length === 0) {
				<div class="empty-ci-indicators">Nenhum indicador de CI disponivel para os filtros selecionados.</div>
			}
			@if (!isLoadingCiIndicators && (cmdbCockpitCards.length > 0 || cmdbCockpitCharts.length > 0)) {
				<pcp-cockpit-chart
					[labels]="labels"
					[cockpitCards]="cmdbCockpitCards"
					[cockpitCharts]="cmdbCockpitCharts"
					[showChartValues]="selectedValuesFilters.showChartValues">
				</pcp-cockpit-chart>
			}
		</div>
	</div>
</div>
